import React from "react";

export default function onScrollWrap(WrappedComponent) {
  return class ElementProperties extends React.Component {
    constructor(props) {
      super(props);

      this.throttleScroll = this.throttleScroll.bind(this);
      this.wrapperRef = React.createRef();

      this.state = {
        top: null,
        left: null,
        right: null,
        bottom: null,
        x: null,
        y: null,
        width: null,
        height: null,
      };
    }

    throttleScroll() {
      const rect = this.wrapperRef.current.getBoundingClientRect();
      const scrollTop = document.body.scrollTop;

      this.setState({
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        scrollTop,
      });
    }

    componentDidMount() {
      this.throttleScroll();
      window.addEventListener("scroll", this.throttleScroll);
    }

    componentWillUnmount() {
      window.removeEventListener("scroll", this.throttleScroll);
    }

    render() {
      return (
        <WrappedComponent
          ref={this.wrapperRef}
          elementPosition={this.state}
          {...this.props}
        />
      );
    }
  };
}
